import leaflet from 'leaflet'
import Layer from './Layer'
import { withMapContext } from './mapContext'

class TopowebLayer extends Layer {

    createLayer() {
        return leaflet.tileLayer.wms(this.props.url, {
            layers: this.props.layers,
            format: 'image/jpeg',
            version: '1.1.1'
        })
    }

}

export default withMapContext(TopowebLayer)


// WEBPACK FOOTER //
// ./src/components/Leaflet/WMSLayer.js